/* Шапка */

const $header = $('.js-header');
const $burgerMenu = $('.js-burger-menu');
const $burgerMenuBtn = $('.js-menu-burger-btn');
const $burgerMenuTitle = $('.js-burger-menu-title');
const $openSearchForm = $('.js-open-search-form');
const $headerSearchCloseForm = $('.js-header-search-close-form');
const $headerSearchField = $('.js-header-search-field');

$burgerMenuBtn.on('click', function (e) {
    const menuOpen = $burgerMenu.is('._open');

    $burgerMenu.toggleClass('_open');

    if (menuOpen) {
        App.lockScroll.unlock();
    } else {
        App.lockScroll.lock();
    }

    e.preventDefault();
});

$openSearchForm.on('click', function (e) {
    $header.addClass('_search-form-opened');
    $headerSearchField.focus();

    e.preventDefault();
});

$headerSearchCloseForm.on('click', function (e) {
    $header.removeClass('_search-form-opened');

    e.preventDefault();
});

if (App.mobilePhone) {
    $burgerMenuTitle.on('click', function (e) {
        if ($(e.target).closest('svg').length) {
            $(this).toggleClass('_open').siblings('.js-burger-menu-list').stop().slideToggle();

            e.preventDefault();
        }

        console.log(e);
    });
}



// WEBPACK FOOTER //
// ./_src/js/Header.js